/*
 * pdp-shipping-eta.js: live countdown to the weekday dispatch cutoff.
 * Reads cutoff hour/minute + IANA timezone from the data attributes on
 * [data-pdp-shipping-eta]. Updates the headline text every minute.
 *
 * Before cutoff: "Order in the next 2h 18m for same-day dispatch"
 * After cutoff: Same-day dispatch may still be possible.
 */
(function () {
  if (window.__pdpShippingEtaWired) return;
  window.__pdpShippingEtaWired = true;

  function formatRemaining(ms) {
    var totalMin = Math.max(0, Math.floor(ms / 60000));
    var h = Math.floor(totalMin / 60);
    var m = totalMin % 60;
    if (h > 0) return h + 'h ' + m + 'm';
    return m + 'm';
  }

  function getNowInTimezone(timezone) {
    // Compose a Date that represents "now" in the given IANA timezone by
    // parsing Intl-formatted parts. This gives us hour/minute/second of the
    // store's local day, independent of the visitor's timezone.
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      hour: 'numeric', minute: 'numeric', second: 'numeric',
      hour12: false,
      year: 'numeric', month: 'numeric', day: 'numeric',
      weekday: 'short'
    });
    var parts = fmt.formatToParts(new Date()).reduce(function (acc, p) {
      acc[p.type] = p.value;
      return acc;
    }, {});
    return {
      hour: parseInt(parts.hour, 10) % 24,
      minute: parseInt(parts.minute, 10),
      second: parseInt(parts.second, 10),
      weekday: parts.weekday, // "Mon", "Tue", ...
      ms: Date.now()
    };
  }

  function isWeekend(weekdayShort) {
    return weekdayShort === 'Sat' || weekdayShort === 'Sun';
  }

  // Returns the human-readable name of the next courier pickup day.
  // Assumes Mon-Fri pickup before the cutoff time.
  //   On a weekday before cutoff: not used (we show the countdown instead).
  //   On a weekday after cutoff: next pickup is the next weekday.
  //   On Saturday or Sunday: next pickup is Monday.
  function nextPickupDayLabel(weekdayShort, isPastCutoff) {
    if (weekdayShort === 'Fri' && isPastCutoff) return 'Monday';
    if (weekdayShort === 'Sat') return 'Monday';
    if (weekdayShort === 'Sun') return 'tomorrow';
    // Mon-Thu after cutoff
    return 'tomorrow';
  }

  function update(el) {
    var cutoffHour = parseInt(el.dataset.cutoffHour, 10);
    if (!Number.isFinite(cutoffHour)) cutoffHour = 12;
    var cutoffMinute = parseInt(el.dataset.cutoffMinute, 10) || 0;
    var timezone = el.dataset.timezone || 'America/Regina';
    var beforeTpl = el.dataset.beforeTemplate || 'Order in __TIME__ for same-day dispatch of in-stock items';
    var afterTpl = el.dataset.afterTemplate || 'Orders after noon may still ship today; otherwise, they ship __NEXT_DAY__.';
    var headline = el.querySelector('[data-pdp-shipping-eta-headline]');
    if (!headline) return;

    var now;
    try {
      now = getNowInTimezone(timezone);
    } catch (e) {
      // If Intl can't resolve the timezone, just show the static label.
      headline.textContent = 'In-stock orders before noon CST, Monday to Friday, ship the same day. Later orders may still ship that day.';
      return;
    }

    var nowMinutes = now.hour * 60 + now.minute;
    var cutoffMinutes = cutoffHour * 60 + cutoffMinute;
    var pastCutoff = nowMinutes >= cutoffMinutes;

    if (isWeekend(now.weekday)) {
      headline.textContent = 'In-stock orders ship ' + nextPickupDayLabel(now.weekday, pastCutoff) + '.';
      return;
    }

    if (pastCutoff) {
      var nextDay = nextPickupDayLabel(now.weekday, pastCutoff);
      headline.textContent = afterTpl
        .replace('__NEXT_DAY__', nextDay)
        .replace('__TIME__', '');
      return;
    }

    var minutesLeft = cutoffMinutes - nowMinutes;
    var secondsLeft = 60 - now.second; // for a smoother countdown on the minute boundary
    var msLeft = (minutesLeft - 1) * 60000 + secondsLeft * 1000;
    headline.textContent = beforeTpl
      .replace('__TIME__', formatRemaining(msLeft))
      .replace('__NEXT_DAY__', 'tomorrow');
  }

  function start() {
    var els = document.querySelectorAll('[data-pdp-shipping-eta]');
    if (!els.length) return;
    els.forEach(update);
    // Update every 30 seconds for snappy minute transitions.
    setInterval(function () {
      els.forEach(update);
    }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
